import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class SignalrConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	getApiToken(): string {
		return this.configService.get((x) => x.core.appContext.apiToken);
	}

	isAcknowledgementEnabled(): boolean {
		return this.configService.get((x) => x.core.signalr.isAcknowledgementEnabled, false);
	}

	getCustomerTransmitSignalRNotificationUrl(): string {
		return this.configService.get((x) => x.core.signalr.customerTransmitEndpoint);
	}

	getGroupTransmitSignalRNotificationUrl(): string {
		return this.configService.get((x) => x.core.signalr.groupTransmitEndpoint);
	}
}
